// extracted by mini-css-extract-plugin
export default {"pointer":"products_pointer__fbYad","cardImage":"products_cardImage__Ef2eg","fSecCard":"products_fSecCard__9NZ5T","bounce":"products_bounce__RGgxv"};